module.exports = __webpack_public_path__ + "img/feature-5@2x.60367eed.jpg";